/**
 * @author       sammy.dowds@zumper.com (Sammy Dowds)
 * @copyright    Copyright (c) 2023, Zumper
 */

import * as Api from '@zcode/nr/es/shared/api'
import type { RouteComponentProps } from '@zcode/router-utils'
import { getVerticalsArray } from '../../../inspectors/index'
import { logger } from '../../../logger'
import type { Dispatch, GetState } from '../../types'
import {
  errorFetchingCityGuideCityData,
  receiveCityGuideCityData,
  startFetchingCityGuideCityData,
} from '../actions/index'
import { selectCityGuideCity, selectCityGuideCityKey } from '../selectors/cityGuideCity'

export const loadCityGuideCity =
  (routeProps: RouteComponentProps, cityState?: string, propertyType?: string) =>
  async (dispatch: Dispatch, getState: GetState) => {
    if (!cityState || !propertyType) {
      return
    }

    const state = getState()
    const key = selectCityGuideCityKey(state)
    const existingData = selectCityGuideCity(state)
    const newKey = `${cityState}/${propertyType}`
    const verticalsArray = getVerticalsArray(routeProps)

    // skip fetch if we have fetched this before and if data exists
    if (key === newKey && Object.keys(existingData).length) {
      return
    }

    dispatch(startFetchingCityGuideCityData(newKey))
    await Api.cityGuideCity
      .get({
        cityState,
        propertyType,
        vertical: verticalsArray?.length ? `/${verticalsArray[0].replace(' ', '-')}` : undefined,
      })
      .then((city) => {
        dispatch(receiveCityGuideCityData(city))
      })
      .catch((error) => {
        dispatch(errorFetchingCityGuideCityData(error?.data?.reason))
        logger.debug('Loading seo content city data failed:', error.data?.reason || error)
      })
  }
